<template>
  <div class="main-container" ref="mainContainer">
    <div class="main-table">
      <div class="search-form-box">
        <SearchForm
          :searchItems="searchItems"
          :showMoreBtn="false"
          v-on:refresh="refresh"
          ref="search"
        />
      </div>
      <div class="button-group" style="display: inline-flex;">
        <el-button icon="el-icon-plus" size="small" type="primary" @click="addData">新增</el-button>
        <el-upload
          class="upload-demo"
          action
          :on-change="handleChange"
          :show-file-list="false"
          :on-remove="handleRemove"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :auto-upload="false"
        >
          <el-button icon="iconfont icon-daoru" size="small" type="primary">导入</el-button>
        </el-upload>
        <div style="width: 164px;font-size: 13px;margin-top: 10px;color: red;">注：支持xlsx、xls文件</div>
      </div>
      <div class="main-table-list">
        <List
          :height="tableHeight"
          :isSelection="false"
          :isIndex="true"
          :columns="tableCols"
          :data="tableData"
          stripe
          ref="list"
          :operates="operates"
        />
      </div>
      <div class="main-pagination">
        <Pagination :data="pagination" @refresh="pageData" ref="pagination" />
      </div>
    </div>
    <Edit ref="edit" v-on:refreshData="refreshData"></Edit>
    <FormDialog title="定位" :isShow="positioningShow" width="944px" v-on:resetForm="close()">
      <div style="padding: 5px 20px;height: 500px;">
      <div style="width: 100%;height: 100%;">
          <vimportmap @ready="readyHandler"></vimportmap>
      </div>
      </div>
    </FormDialog>
    <FormDialog title="全景" :isShow="panoramicViewShow" width="944px" v-on:resetForm="close()">
      <div style="padding: 0px 10px;height: 500px;">
      <div style="width: 100%;height: 100%;">
          <photosphereviewer v-if="photosphereviewerFlag" :tableImgHeight="'490px'" :landinfo ="landinfo" ></photosphereviewer>
      </div>
      </div>
    </FormDialog>
  </div>
</template>
<script>
import { landinifoApi, userInfoApi } from '@/api/managementSystemApi'
import { Notification } from 'element-ui'
import { xzqUtils } from '@/views/class/mapmanager'
import SearchForm from '@/components/form/searchForm'
import Pagination from '@/components/pagination/default'
import List from '@/components/list/default'
import Edit from './edit'
import XLSX from 'xlsx'
import { importLand } from '@/views/class/importLand'
import vimportmap from 'components/main-map/import-map'
import photosphereviewer from 'components/main-map/photosphereviewer'
import FormDialog from '@/components/dialog/formDialog'
export default {
  name: 'land',
  components: {
    SearchForm,
    Pagination,
    List,
    Edit,
    XLSX,
    FormDialog,
    vimportmap,
    photosphereviewer
  },
  data() {
    return {
      photosphereviewerFlag: false,
      map: null,
      tableCols: [
        { label: '行政区', prop: 'xzqmc', width: 80 },
        { label: '地块名称', prop: 'dkmc', width: 280 },
        { label: '宗地位置', prop: 'dkdz' },
        { label: '宗地面积(亩)', prop: 'dkmj', width: 120 },
        { label: '土地用途', prop: 'tdyt', width: 200 },
        { label: '发布状态', prop: 'status', width: 100 }
      ],
      searchItems: [],
      searchParams: [],
      operates: {
        width: 250,
        list: [
          {
            id: '2',
            label: '查看',
            type: 'text',
            show: true,
            disabled: false,
            size: 'small',
            method: (index, row) => {
              this.toView(row)
            }
          },
          {
            id: '1',
            label: '修改',
            type: 'text',
            show: true,
            disabled: false,
            size: 'small',
            method: (index, row) => {
              const registerType = localStorage.registerType
              if (registerType === '0') {
                if (row.status && row.status === '已保存') {
                  this.handlCheck(row)
                } else {
                  const status = row.status
                  Notification.warning({
                    title: '提示',
                    message: '该地块的信息' + status + ',无法进行修改!',
                    type: 'warning'
                  })
                }
              } else {
                this.handlCheck(row)
              }
            }
          },
          {
            id: '1',
            label: '删除',
            type: 'text',
            show: true,
            disabled: false,
            size: 'small',
            method: (index, row) => {
              this.$confirm('此操作将永久删除该地块, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  // 删除的逻辑
                  this.deleteIdLand(row)
                })
            }
          },
          {
            id: '1',
            label: '定位',
            type: 'text',
            show: true,
            disabled: false,
            size: 'small',
            method: (index, row) => {
              this.positioning(row)
            }
          },
          {
            id: '1',
            label: '全景',
            type: 'text',
            show: true,
            disabled: false,
            size: 'small',
            method: (index, row) => {
              if (row.qjt) {
                this.panoramicView(row)
              } else {
                Notification.warning({
                  title: '提示',
                  message: '该地块没有全景图!',
                  type: 'warning'
                })
              }
            }
          }
        ]
      },
      pagination: { pageSize: 10, pageNum: 1, total: 0 }, // 分页数据
      tableData: [],
      companys: [],
      rowData: {},
      landinfo: null,
      tableHeight: 0,
      pageLength: 10,
      pageNum: 1,
      pageTotal: 0,
      positioningShow: false,
      panoramicViewShow: false,
      title: '',
      otherTitle: '',
      xzqArray: []
    }
  },
  watch: {
    tableHeight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tableHeight = this.$refs.mainContainer.offsetHeight - 205
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.mainContainer.offsetHeight - 205
    })
  },
  created() {
    debugger
    this.xzqArray = JSON.parse(localStorage.getItem('xzqList'))
    this.getData()
  },
  methods: {
    positioning(rowData) {
      if (rowData.dkzb && rowData.dkzb !== '') {
        this.positioningShow = true
        setTimeout(() => {
          this.addLayer(true, rowData)
        }, 300)
      } else {
        Notification.warning({
          title: '警告',
          message: '当前地块不存在项目红线...',
          type: 'warning'
        })
      }
    },
    readyHandler(map) {
      this.map = map
    },
    addLayer(isPositon, rowData) {
      if (this.map) {
        this.map.importLayerGroup.clearLayers()
        if (rowData.dkzb && rowData.dkzb !== '') {
          const highlightLayer = L.geoJSON(JSON.parse(rowData.geojson), { color: 'red', weight: 2, fillColor: 'red', fillOpacity: 0.2 })
          this.map.importLayerGroup.addLayer(highlightLayer)
          const bounds = this.map.importLayerGroup.getBounds()
          this.map.fitBounds(bounds)
        } else {
          if (isPositon) {
            Notification.warning({
              title: '警告',
              message: '当前地块不存在项目红线...',
              type: 'warning'
            })
          }
        }
      }
    },
    panoramicView(rowData) {
      this.landinfo = rowData
      this.panoramicViewShow = true
      setTimeout(() => {
        this.photosphereviewerFlag = true
      }, 300)
    },
    close() {
      this.positioningShow = false
      this.panoramicViewShow = false
      this.photosphereviewerFlag = false
    },
    getData() {
      const _this = this
      const params = {
        pageNo: 0,
        pageSize: 0,
        params: [
          {
            column: 'create_time',
            type: 'ORDERBY',
            val: 'desc'
          }, {
            column: 'id',
            type: 'ORDERBY',
            val: 'asc'
          }]
      }
      userInfoApi.selectCompany(params).then(response => {
        if (response.code === '200') {
          const data = response.data
          const companysArray = new Array()
          const all = []
          all.label = '全部'
          all.value = '全部'
          companysArray.push(all)
          for (let i = 0; i < data.length; i++) {
            const datas = []
            datas.label = data[i].companyname
            datas.value = data[i].companyname
            companysArray.push(datas)
          }
          _this.companys = companysArray
          _this.searchItems = [
            {
              label: '行政区',
              type: 'select',
              prop: 'xzq',
              options: this.xzqArray
            },
            { label: '地块名称', type: 'text', prop: 'dkmc' },
            {
              label: '用地性质',
              type: 'select',
              prop: 'ydxz',
              options: [
                { label: '全部', value: '0' },
                { label: '住宅用地', value: '1' },
                { label: '商服用地', value: '2' },
                { label: '工业用地', value: '3' },
                { label: '其他', value: '4' }
              ]
            },
            {
              label: '发布状态',
              type: 'select',
              prop: 'status',
              width: 200,
              options: [
                { label: '全部', value: '-1' },
                { label: '已保存', value: '0' },
                { label: '已提交', value: '1' },
                { label: '已发布', value: '2' },
                { label: '已下架', value: '3' }
              ]
            }
          ]
        }
      })
      this.queryData()
    },
    queryData(pageNumber, pageLength, pageTotal, title, otherTitle) {
      const searchParams = this.searchParams
      const params = this.getSearchParams(searchParams)
      let pageNo = 0
      let pageSize = 0
      let total = 0
      if (title == '删除' || otherTitle == '编辑保存') {
        if (pageNumber) {
          pageNo = pageNumber
        }
        if (pageLength) {
          pageSize = pageLength
        }
        if (pageTotal) {
          total = pageTotal
        }
      } else {
        if (pageNumber) {
          pageNo = 1
        }
        if (pageLength) {
          pageSize = pageLength
        }
        if (pageTotal) {
          total = pageTotal
        }
      }
      params.pageNo = pageNo
      params.pageSize = pageSize
      params.total = total
      landinifoApi.selectByPage(params).then(response => {
        if (response.code === '200') {
          this.tableData = []
          const list = response.data.list
          list.forEach(element => {
            element.xzqmc = xzqUtils.getXZQNAME(element.xzq)
            if (element.status) {
              if (element.status === '0') {
                element.status = '已保存'
              } else if (element.status === '1') {
                element.status = '已提交'
              } else if (element.status === '2') {
                element.status = '已发布'
              } else {
                element.status = '已下架'
              }
            }
          })
          if (list.length < this.pageLength) {
            this.tableData = list
          } else {
            for (let i = 0; i < this.pageLength; i++) {
              this.tableData.push(list[i])
            }
          }
          this.pagination.total = response.data.total
          if (this.title == '删除' || this.otherTitle == '编辑保存') {
            this.pagination.pageNum = this.pageNum
            this.title = ''
            this.otherTitle = ''
          } else {
            this.pagination.pageNum = 1
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.pagination.total = 0
        }
      })
    },
    getSearchParams(data) {
      const searchParams = this.searchParams
      let tsqdw = ''
      let tydxz = ''
      let txzq = ''
      let tdkmc = ''
      let userID = ''
      let tstatus = ''
      if (localStorage.registerType == '0' && localStorage.userId != undefined) {
        userID = localStorage.userId
      }
      if (searchParams.length === 0) {
      } else {
        for (let i = 0; i < searchParams.length; i++) {
          if (searchParams[i].column == 'sqdw') {
            tsqdw = searchParams[i].val
            if (tsqdw == '全部') {
              tsqdw = ''
            }
          }
          if (searchParams[i].column == 'ydxz') {
            tydxz = searchParams[i].val
            if (tydxz == '0') {
              tydxz = ''
            }
          }
          if (searchParams[i].column == 'xzq') {
            txzq = searchParams[i].val
            if (txzq == '0') {
              txzq = ''
            }
          }
          if (searchParams[i].column == 'dkmc') {
            tdkmc = searchParams[i].val
          }
          if (searchParams[i].column == 'status') {
            tstatus = searchParams[i].val
            if (tstatus == '-1') {
              tstatus = ''
            }
          }
        }
      }

      const params = {
        pageNo: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        total: this.pagination.total,
        params: [
          {
            column: 'sqdw',
            type: 'EQ',
            val: tsqdw
          },
          {
            column: 'ydxz',
            type: 'EQ',
            val: tydxz
          },
          {
            column: 'xzq',
            type: 'EQ',
            val: txzq
          },
          {
            column: 'dkmc',
            type: 'LIKE',
            val: tdkmc
          },
          {column: 'userId',
            type: 'EQ',
            val: userID
          },
          {
            column: 'create_time',
            type: 'ORDERBY',
            val: 'desc'
          },
          {
            column: 'id',
            type: 'ORDERBY',
            val: 'asc'
          },
          {
            column: 'status',
            type: 'eq',
            val: tstatus
          }]
      }
      return params
    },
    pageData(data) {
      const params = this.getSearchParams(data)
      this.pageLength = data.pagination.pageSize
      this.pageNum = data.pagination.pageNum
      this.pageTotal = this.pagination.total
      landinifoApi.selectByPage(params).then(response => {
        if (response.code === '200') {
          this.tableData = []
          const list = response.data.list
          list.forEach(element => {
            element.xzqmc = xzqUtils.getXZQNAME(element.xzq)
            if (element.status) {
              if (element.status === '0') {
                element.status = '已保存'
              } else if (element.status === '1') {
                element.status = '已提交'
              } else if (element.status === '2') {
                element.status = '已发布'
              } else {
                element.status = '已下架'
              }
            }
          })
          this.tableData = list
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.pagination.total = 0
        }
      })
    },
    handlCheck(row) {
      this.rowData = row
      this.rowData = JSON.stringify(this.rowData)
      this.editData = JSON.parse(this.rowData)
      this.otherTitle = '编辑保存'
      this.$refs.edit.open(row.id, this.editData, '编辑')
    },
    toView(row) {
      this.rowData = row
      this.rowData = JSON.stringify(this.rowData)
      this.editData = JSON.parse(this.rowData)
      this.$refs.edit.open(row.id, this.editData, '查看')
    },
    deleteIdLand(row) {
      if (row) {
        const id = row.id
        const params = {
          id
        }
        landinifoApi.deleteIdLandInfo(params).then(response => {
          if (response.code === '200') {
            this.$utils.success('删除成功！')
            this.title = '删除'
            this.queryData(this.pageNum, this.pageLength, this.pageTotal, this.title)
          } else {
            this.$utils.success('删除失败！')
          }
        })
      }
    },
    refresh(data) {
      this.searchParams = data.searchParams
      const params = this.getSearchParams(data)
      params.pageNo = 1
      params.pageSize = this.pageLength
      this.pageNum = 1
      landinifoApi.selectByPage(params).then(response => {
        if (response.code === '200') {
          if (response.data.length === 0) {
            this.tableData = []
            this.pagination.total = 0
            Notification.warning({
              title: '提示',
              message: '暂未查到数据!',
              type: 'warning'
            })
          } else {
            this.tableData = []
            const list = response.data.list
            list.forEach(element => {
              element.xzqmc = xzqUtils.getXZQNAME(element.xzq)
              if (element.status) {
                if (element.status === '0') {
                  element.status = '已保存'
                } else if (element.status === '1') {
                  element.status = '已提交'
                } else if (element.status === '2') {
                  element.status = '已发布'
                } else {
                  element.status = '已下架'
                }
              }
            })
            this.tableData = list
            this.pagination.total = response.data.total
            this.pagination.pageNum = 1
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.pagination.total = 0
        }
      })
    },
    addData() {
      this.searchParams = []
      this.otherTitle = '新增保存'
      this.$refs.edit.open(0)
    },
    // 刷新
    refreshData() {
      this.queryData(this.pageNum, this.pageLength, this.pageTotal, this.title, this.otherTitle)
    },
    // excel表上传
    handleChange(file, fileList) {
      this.fileTemp = file.raw
      // 判断上传文件格式
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          this.fileTemp.type == 'application/vnd.ms-excel'
        ) {
          this.importfxx(this.fileTemp)
        } else {
          this.$message({
            type: 'warning',
            message: '附件格式错误，请删除后重新上传！'
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请上传附件！'
        })
      }
    },
    // 移除excel表
    handleRemove(file, fileList) {
      this.fileTemp = null
    },
    importfxx(obj) {
      importLand.importLandList(obj, this.queryImport)
    },
    queryImport(tLandinfos) {
      if (tLandinfos && tLandinfos.length > 0) {
        let flag = false
        for (let i = 0; i < tLandinfos.length; i++) {
          tLandinfos[i].userId = localStorage.userId
          const numberReg = /^-?\d{1,16}(?:\.\d{0,12})?$/
          if (tLandinfos[i].pgzj && !numberReg.test(tLandinfos[i].pgzj)) {
            flag = true
          }
          if (tLandinfos[i].pgmjj && !numberReg.test(tLandinfos[i].pgmjj)) {
            flag = true
          }
          if (tLandinfos[i].pglmdj && !numberReg.test(tLandinfos[i].pglmdj)) {
            flag = true
          }
        }
        if (flag) {
          Notification.warning({
            title: '提示',
            message: '导入失败！评估亩均价、评估总价、楼面地价只能是数字,请修改后再导入!',
            type: 'warning'
          })
        } else {
          landinifoApi.addListTLandInfo(tLandinfos).then(response => {
            if (response.code === '200' && response.data) {
              this.$utils.success('导入成功！')
              this.queryData(this.pageNum, this.pageLength, this.pageTotal)
            } else {
              this.$utils.error(
                '导入失败！失败原因是该地块已存在或者表格数据有误'
              )
            }
          })
        }
      } else {
        this.$utils.info('未查到相关数据,请重新选择文件！')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/list.scss";
.button-group {
  ::v-deep {
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
.upload-demo {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
